import {
  Addchart,
  DeleteOutlined,
  SubdirectoryArrowRight,
  Add,
  MoreVert,
} from '@mui/icons-material';
import {
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Stack,
} from '@mui/material';
import { memo, useCallback } from 'react';

function LabelMenuButton({ Icon, onClick }) {
  return (
    <IconButton size="small" onClick={onClick}>
      <Icon sx={{ fontSize: 16 }} />
    </IconButton>
  );
}

function NodeMenus({
  depth,
  nodeId,
  composedNodeId,
  anchorEl,
  handleMenuClose,
  isLeafNode,
  allowAddFeatures,
  handleAction,
  handleMenuOpen,
  handleNodeSelect,
}) {
  const handleAddSibling = useCallback(() => {
    handleAction('add-sibling', nodeId, depth);
    handleMenuClose();
  }, [handleAction, nodeId, depth, handleMenuClose]);

  const handleDelete = useCallback(() => {
    handleAction('delete', nodeId, depth);
    handleNodeSelect(null);
    handleMenuClose();
  }, [handleAction, nodeId, depth, handleNodeSelect, handleMenuClose]);

  const handleAddFeatures = useCallback(() => {
    handleAction('select-feature', nodeId, depth);
    handleMenuClose();
  }, [handleAction, nodeId, depth, handleMenuClose]);

  return (
    <Stack direction="row" alignItems="center" justifyContent="flex-start" pr={1}>
      <Divider orientation="vertical" sx={{ mx: 0.5, height: 24, color: 'grey.400' }} />

      {!isLeafNode && (
        <LabelMenuButton Icon={Add} onClick={() => handleAction('add', nodeId, depth)} />
      )}

      <LabelMenuButton
        Icon={MoreVert}
        onClick={(e) => handleMenuOpen(e, composedNodeId)}
      />

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        onClick={(e) => e.stopPropagation()}
      >
        <MenuItem onClick={handleAddSibling}>
          <SubdirectoryArrowRight fontSize="small" sx={{ mr: 1 }} />
          Add Sibling
        </MenuItem>

        <MenuItem onClick={handleDelete}>
          <DeleteOutlined fontSize="small" sx={{ mr: 1 }} />
          Delete Node
        </MenuItem>

        {allowAddFeatures && (
          <MenuItem onClick={handleAddFeatures}>
            <Addchart fontSize="small" sx={{ mr: 1 }} />
            Add Features
          </MenuItem>
        )}
      </Menu>
    </Stack>
  );
}

export default memo(NodeMenus);
